import React from 'react'
import ReactDOM from 'react-dom'
import thunk from 'redux-thunk'
import ReactGA from 'react-ga'

import { googleAnalytics } from './reactGAMiddlewares'

import { createStore, applyMiddleware, compose } from 'redux'

import { Provider } from 'react-redux'

import { combinedReducers, initialState } from './reducers'

import createHistory from 'history/createBrowserHistory'

import { ConnectedRouter, routerMiddleware } from 'react-router-redux'


import './index.css';
import App from './components/app/App';
import ScrollToTop from './components/scrolltotop/ScrollToTop'
import registerServiceWorker from './registerServiceWorker';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory()

ReactGA.initialize('UA-19654134-2')

// Build the middleware for intercepting and dispatching navigation actions
const middleware = applyMiddleware(
  routerMiddleware(history),
  thunk
)

// Add the reducer to your store on the `router` key
// Also apply our middleware for navigating
const store = createStore(
  combinedReducers,
  initialState,
  compose (
    middleware,
    applyMiddleware(googleAnalytics)
  )
)


ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <ScrollToTop>
        <App />
      </ScrollToTop>
     </ConnectedRouter> 
  </Provider>,

  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js